<template>
  <div class="user_info_body">
    <div class="deco">
      <div class="user_info_form">
        <h4>기본 정보</h4>
        <v-button @handleClick="goToChangeUserInfo" text="사업자 회원으로 변경" class="btn06 corner"></v-button>
        <dl>
          <dt>사용자 유형</dt>
          <dd>개인</dd>
        </dl>
        <dl>
          <dt>이름</dt>
          <dd>{{ userInfo.userName }}</dd>
        </dl>
      </div>

      <div class="user_info_form">
        <h4>연락처</h4>
        <dl>
          <dt>전화번호</dt>
          <dd>{{ userInfo.telNo }}</dd>
        </dl>
        <dl class="address">
          <dt>주소</dt>
          <dd>({{ userInfo.zipCode }}) {{ userInfo.address1 }} {{ userInfo.address2 }}</dd>
        </dl>
        <div class="bt">
          <v-button
            @handleClick="isContactModify = true"
            text="연락처 수정"
            class="btn06"
            :disabled="isContactModify"
          ></v-button>
        </div>
      </div>

      <modify-contact v-if="isContactModify" @cancel-click="isContactModify = false"></modify-contact>

      <div class="user_info_form">
        <h4>지급 계좌</h4>
        <dl>
          <dt>은행</dt>
          <dd>{{ userInfo.bankName }}</dd>
        </dl>
        <dl>
          <dt>계좌번호</dt>
          <dd>{{ userInfo.accountNo }}</dd>
        </dl>
        <dl>
          <dt>계좌주</dt>
          <dd>{{ userInfo.accountOwnerName }}</dd>
        </dl>
        <div class="bt">
          <v-button
            @handleClick="isAccountModify = true"
            text="계좌 수정"
            class="btn06"
            :disabled="isAccountModify"
          ></v-button>
        </div>
      </div>

      <register-account
        v-if="isAccountModify"
        @cancel-click="isAccountModify = false"
        :isButton="true"
        :businessType="1"
        class="user_info_form_account"
      ></register-account>
    </div>

    <div v-if="!userInfo.isCheckedIdNo" class="delete_btn_wrap">
      <!--    <div class="delete_btn_wrap">-->
      <v-button @handleClick="removeWithdrawalInfo" text="출금정보 삭제하기" class="btn23"></v-button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VButton from '@/components/atoms/VButton';
import ModifyContact from '@/components/modules/userInfo/ModifyContact';
import RegisterAccount from '@/components/modules/userInfo/RegisterAccount';
import { i18n } from '@/plugins/lang';

export default {
  components: {
    VButton,
    ModifyContact,
    RegisterAccount,
  },
  data() {
    return {
      isContactModify: false,
      isAccountModify: false,
      isDeleteWithdrawalInfo: false,
    };
  },
  computed: {
    ...mapGetters('userInfo', ['userInfo']),
  },
  methods: {
    ...mapActions('modal', ['openModal', 'closeModal']),
    ...mapActions('userInfo', ['delWithdrawalInfo']),
    goToChangeUserInfo() {
      return this.$router.replace({ name: 'UserInfoChange' });
    },
    removeWithdrawalInfo() {
      this.openModal({
        type: 'confirm',
        // message: '출금정보를 정말 삭제하시겠습니까 ?<br />입력한 출금 정보는 모두 삭제됩니다.',
        message: i18n.t('userInfo.removeWithdrawalInfo'),
        callback: () => {
          setTimeout(async () => {
            if (this.userInfo.status === 1) {
              this.openModal({
                type: 'alert',
                // message: '아직 처리되지 않은 사업자 신청 내역이 있습니다.<br />처리 중에는 출금정보 삭제가 불가합니다.',
                message: i18n.t('userInfo.underReview'),
              });
            } else {
              const apiReturn = await this.delWithdrawalInfo();
              if (apiReturn === 0) {
                this.openModal({
                  type: 'alert',
                  // message: '처리가 완료되었습니다.',
                  message: i18n.t('userInfo.processingCompleted'),
                  callback: () => {
                    return this.$router.go();
                  },
                });
              } else if (apiReturn === 6003) {
                this.openModal({
                  type: 'alert',
                  // message: '아직 처리되지 않은 사업자 신청 내역이 있습니다.<br />처리 중에는 출금정보 삭제가 불가합니다.',
                  message: i18n.t('userInfo.underReview'),
                });
              } else {
                this.openModal({
                  type: 'alert',
                  message: i18n.t('error.common.temporaryError'),
                });
              }
            }
          }, 330);
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.btn06 {
  &.corner {
    position: absolute;
    top: 30px;
    right: 0;
  }
}
.delete_btn_wrap {
  display: flex;
  height: 70px;
  flex-direction: row-reverse;
  align-items: flex-end;
  align-content: flex-end;
}
.btn23 {
  background-color: #e6e9eb;
  border: 1px solid #e1e3f0;
  color: #666666;
  &:hover,
  &:active {
    color: #4a4545;
    background-color: #bfc1cd;
  }
}
</style>
